import io from "socket.io-client"

export default class ChatSocket {
	constructor(store = null, params = {}) {
		this.handlers = {
			'new-message': [],
			'del-message': [],
			'typing': [],
		};
		this.params = params
		this.store = store || hp.store;
		if (!this.store.chat) {
			this.store.chat = {
				chat: {},
				users: {},
				unread: {} // guarda, por user, o numero de mensagens não lidas
			}
		}
		if (!this.store.me) {
			this.store.me = {groups: null}
		}
		this.alias = this.store.alias;
		this.socket = io(hp.settings.chat.server, {autoConnect: false});
		this.socket
			.on('new-message', (data) => {
				if (!window.document.hasFocus()) {
					const notif = new Audio(hp.settings.tpldns + 'admin/sounds/notification.mp3');
					try {
						notif.play()
					}
					catch(ex) {
					}
				}
				if (this.params.onNewMessage instanceof Function) {
					this.params.onNewMessage(data)
					return
				}
				// vai buscar a mensagem gravada
				this.load(!data.group_id || data.group_id == 0 ? data.user_id : data.group_id, 1).then(response => {
					this.raiseEvents('new-message', {chat: response})
				})
			})
			.on('typing', (data) => {
				const users = this.store.chat.users;

				if (data.group_id && users.hasOwnProperty(data.group_id)) {
					users[data.group_id].typing = data.typing;
					this.raiseEvents('typing', data);
				}
				else if (users.hasOwnProperty(data.user_id)) {
					users[data.user_id].typing = data.typing;
					this.raiseEvents('typing', data);
				}
			})
			.on('del-message', (data) => {
				const chat = this.store.chat.chat;
				if (!chat.hasOwnProperty(data.to) || !chat[data.to][data.id]) {
					return;
				}
				chat[data.to][data.id].href = null;
				chat[data.to][data.id].deleted = true;
				this.raiseEvents('del-message', data);
			})
		this.socket.connect()
		this.connect()
		this.socket
			.on('connect', number => {
				this.connect()
			})
			.on('connect_error', () => console.log('chat: error connect to socket server'));
	}

	connect() {
		this.socket.emit('add-user', hp.settings.chat.nif, {
			id: this.store.uid,
			room: this.alias,
			token: hp.settings.chat.token,
			groups: this.store.me.groups
		})
	}

	subscribe(type, handler) {
		if (!this.handlers[type]) {
			return -1;
		}
		const idx = Object.keys(this.handlers[type]).length;
		this.handlers[type][idx] = handler;
		return idx;
	}

	unsubscribe(type, handlerIdx) {
		if (this.handlers[type] && this.handlers[type].hasOwnProperty(handlerIdx)) {
			delete this.handlers[type][handlerIdx];
		}
	}

	raiseEvents(type, params = null) {
		if (this.handlers[type]) {
			setTimeout( () => {
				this.handlers[type].forEach(handler => {
					handler(params);
				})
			});
		}
	}

	send(data) {
		return new Promise((resolve, success) => {
			data.silent = true;
			http.post('/chat/send.json', data, (response, success) => {
				if (response && success) {
					if (data instanceof FormData) {
						const _data = {};
						for (let [key, value] of data.entries()) {
							_data[key] = value;
						}
						data = _data;
					}
					// tell server to execute 'new message' and send along one parameter
					this.socket.emit('new-message', data);
					this.mergeResults(response);
				}
				response = response || {};
				response.success = success;
				resolve(response);
			})
		});
	}

	delete(chat_id, to) {
		return new Promise((resolve, success) => {
			http.post('/chat/delete.json', {id: chat_id}, (response, success) => {
				if (response && success) {
					// tell server to execute 'new message' and send along one parameter
					//this.socket.emit('del-message', {chat_id: chat_id, to: to});
					//this.mergeResults(response);
					if (this.store.chat.chat.hasOwnProperty(to)) {
						delete this.store.chat.chat[to][chat_id];
						this.socket.emit('del-message', {to: to, id: chat_id});
						resolve(response);
					}
				}
			})
		});
	}

	setRead(uid) {
		if (this.read_timeout) {
			clearTimeout(this.read_timeout);
		}
		const chat = this.store.chat;

		if (chat.unread[uid] == undefined || chat.unread[uid] == 0) {
			return;
		}
		this.read_timeout = setTimeout(() => {
			http.post('/chat/setChatRead.json', {to: uid, alias: this.alias, silent: true}, response => {
				this.read_timeout = 0;
				delete chat.unread[uid];
				// definir todas as mensagens como lidas
				const user_msgs = chat.chat[uid] || {};

				for (let id in user_msgs) {
					user_msgs[id].read = 1
				}
				this.raiseEvents('new-message');
			});
		}, 1000);
	}

	/**
	 * Load das mensagens da pagina page. Se page = 0, load da pagina seguinte
	 * @param {object} user 
	 * @param {int} page se page = 1, não atualiza user.page, uma vez que é necessário o valor original para o scroll
	 */
	load(user, page = 0) {
		//const { chat } = this.store;
		//const user = chat.users[to];
		if (!(user instanceof Object)) {
			user = this.store.chat.users[user];
		}
		const _page = page || (user.page ? (user.page + 1) : 1);

		//if (page == 0) {
		//	page = user.page ? (user.page + 1) : 1;
		//}
		user.loading = true;
		return new Promise(resolve => {
			http.post('/chat/get.json', {silent: true, alias: this.alias, page: _page, to: user.to_user_id}, response => {
				user.loaded = true;
				user.loading = false;
				user.page = page != 1 || !user.page ? response.page : user.page;
				user.page_count = response.page_count;

				this.mergeResults(response)
				resolve(response)
			})
		})
	}

	mergeResults(response) {
		const {chat} = this.store;
		const user_ids = Object.keys(response.chat);

		user_ids.forEach(uid => {
			const msgs = response.chat[uid];

			for (let mid in msgs) {
				msgs[mid].updated_at = new Date(msgs[mid].updated_at)
			}
			if (chat.chat.hasOwnProperty(uid)) {
				Object.assign(chat.chat[uid], msgs);
			}
			else {
				chat.chat[uid] = msgs;
			}
			// set my last message as editable
			const data = chat.chat[uid];
			const msg_keys = Object.keys(data);

			for (let i = msg_keys.length - 1, my_last = null; i >= 0; i --) {
				const msg = data[msg_keys[i]];

				if (!msg.mine) {
					continue;
				}
				if (msg.editable) {
					break;
				}
				if (my_last == null) {
					my_last = msg;
					msg.editable = true;
				}
			}
		});
		Object.assign(chat.unread, response.unread);

		return user_ids.length > 0;
	}

}
